import { Component } from '@angular/core';

@Component({
  selector: 'app-medicine',
  standalone: true,
  imports: [],
  templateUrl: './medicine.component.html',
  styleUrl: './medicine.component.scss'
})
export class MedicineComponent {

}
